import { jObjectLittleSchema } from './objectBase';
import { z } from 'zod';

export const baseAutocompleteSchema = z.object({
    id: z.string(),
    uri: z.string(),
    shortUri: z.string(),
    title: z.string(),
    name: z.string(),
    mainType: z.string(),
    type: z.string(),
    label: z.string(),
    cssClass: z.string(),
    cssColor: z.string(),
    class: z.string(),
});
export type BaseAutocomplete = z.infer<typeof baseAutocompleteSchema>;

export const jObjectAutocompleteSchema = baseAutocompleteSchema.extend({
    title: z.string(),
});
export type jObjectAutocomplete = z.infer<typeof jObjectAutocompleteSchema>;

export const jUserAutocompleteSchema = jObjectAutocompleteSchema.extend({
    Pseudo: z.string(),
    _url: z.string(),
});
export type jUserAutocomplete = z.infer<typeof jUserAutocompleteSchema>;

export const jSpotAutocompleteSchema = jObjectAutocompleteSchema.extend({
    idspot: z.string(),
});
export type jSpotAutocomplete = z.infer<typeof jSpotAutocompleteSchema>;

export const audienceAutocompleteSchema = z.union([
    jObjectAutocompleteSchema,
    jUserAutocompleteSchema,
    jSpotAutocompleteSchema,
]);
export type AudienceAutocomplete = z.infer<typeof audienceAutocompleteSchema>;

export type CommunityAutocomplete = jObjectAutocomplete;

export const communitySchema = jObjectLittleSchema.extend({
    isTechnical: z.number(),
    status: z.number(),
    image: z.string(),
    isMember: z.boolean(),
    stats: z.object({
        moderators: z.number(),
        members: z.string(),
    }),
    _members: z.array(jObjectLittleSchema),
});
export type Community = z.infer<typeof communitySchema>;

export const autocompleteLittleSchema = baseAutocompleteSchema.pick({ uri: true, title: true });
export type AutocompleteLittleSchema = z.infer<typeof autocompleteLittleSchema>;
